import React from 'react'
import {
	IonText,
	IonButton,
	IonCard,
	IonCardContent,
	IonProgressBar,
	IonSpinner,
} from '@ionic/react'

const ProtocolsList = ({ protocols: allProtocols, onProtocolSelected, onBack, isLoading, error }) => {
	// Premium Lite: journeys outside the plan come back `locked`; onboarding
	// offers only the ones the member can start (the backend refuses the rest).
	const protocols = (allProtocols || []).filter((protocol) => protocol.locked !== true)

	const handleProtocolSelect = (protocol) => {
		onProtocolSelected(protocol)
	}

	if (isLoading && protocols.length === 0) {
		return (
			<div className="loading-container">
				<IonSpinner name="crescent" />
				<IonText>Caricamento protocolli...</IonText>
			</div>
		)
	}

	return (
		<div>
			<h1>Ecco i protocolli più adatti ai tuoi obiettivi</h1>
			<h5>Abbiamo calcolato la percentuale di aderenza in base alle tue scelte.</h5>
			
			{error && (
				<IonText color="danger" className="error">
					{error}
				</IonText>
			)}

			{protocols.map((protocol) => (
				<IonCard key={protocol.id} className="protocol-card">
					<IonCardContent>
						<div className="protocol-header">
							<h3>{protocol.name}</h3>
							<div className="compatibility-info">
								<span className="compatibility-label">Aderenza: {protocol.compatibility}%</span>
								<IonProgressBar
									value={protocol.compatibility / 100}
									color={protocol.compatibility >= 80 ? 'success' : protocol.compatibility >= 60 ? 'warning' : 'danger'}
								/>
							</div>
						</div>

						<div className="protocol-details">
							<div className="matched-goals">
								{protocol.matched_goals.map((goal, index) => (
									<div key={goal.id} className="goal-tag">
										{goal.name}
									</div>
								))}
							</div>
							
							<div className="protocol-actions">
								<IonButton
									fill="outline"
									size="small"
									onClick={() => handleProtocolSelect(protocol)}
									disabled={isLoading}
								>
									{isLoading ? <IonSpinner name="crescent" /> : 'Scopri di più >'}
								</IonButton>
							</div>
						</div>
					</IonCardContent>
				</IonCard>
			))}

			<div className="buttons">
				<IonButton
					shape="round"
					onClick={onBack}
					color="medium"
					expand="full"
				>
					Indietro
				</IonButton>
			</div>
		</div>
	)
}

export default ProtocolsList
